import React, {useState, useEffect} from 'react'
import { useHistory } from 'react-router-dom'

import { EstadoCuentaList } from './Desktop'
import { EstadoCuentaListMovil } from './Movil'
import Loading from 'components/Loading'
import { useEdosCuenta } from './ModulosEdosCuenta';
import { useMovements } from '../6-Movimientos/ModulosMovimientos';
import { useMooksConsultaMovimientos } from '../1-Consulta/ModulosConsulta/mocks'


export default function SolicitarEstadoCuenta() {

    // Moks
    // const { sendMovements, respMovements, cargos, abonos } = useMooksConsultaMovimientos()


    // Productivos
    const { sendMonthList, sendDownloadStatement, errorCode, acountStatusData, dataTransaction, date, loading, isMobile } = useEdosCuenta()

    const { sendMovements, respMovements, cargos, abonos } = useMovements();



    const history = useHistory();

    //- Codigo de instana para track de pagina 
    useEffect(()=>{
        window.ineum('page', 'Bank Statement Credit-Page');
        window.ineum('meta', 'portal', 'Credito');

        //se llaman los meses facturados
        sendMonthList()
        sendMovements()
    },[])

    const [rango, setRango] = useState();
    useEffect(()=>{
        if(rango){
            sendDownloadStatement(rango)
            setRango()
        }
    },[rango])

    return (
        <>
            { loading && <Loading /> }
            {isMobile
                ? isMobile === 'desktop'
                    ?
                        <EstadoCuentaList
                            errorCode={errorCode}
                            acountStatusData={acountStatusData}
                            respMovements={respMovements}
                            dataTransaction={dataTransaction}
                            setRango={setRango}
                            date={date}
                        />
                    :
                        <EstadoCuentaListMovil
                            errorCode={errorCode}
                            acountStatusData={acountStatusData}
                            respMovements={respMovements}
                            dataTransaction={dataTransaction}
                            setRango={setRango}
                            date={date}
                        />
                : null
            }
        </>
    )
}